import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

registerLocaleData(localeDe, 'de');

declare module '@sona/angular-util-environment' {

    interface IEnvironment {
        production: boolean;
        defaultLanguage: string;
        apiUrl: string;
    }
}

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    export namespace NodeJS {

        export interface ProcessEnv {
            NG_APP_ENV: string;
            NG_APP_API_URL: string;
        }
    }
}


declare module '@sona/angular-util-environment' {

    interface IEnvironment {
        production: boolean;
        defaultLanguage: string;
        apiUrl: string;
    }
}

if (environment.production) {
    enableProdMode();
}

Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.name,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration()
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: environment.sentry.tracePropagationTargets,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
});

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
